import {
    MAIN_COMPANY_FILTER,
    MAIN_SALESORG_FILTER,
    MAIN_CHANNEL_FILTER,
    MAIN_IMPORT_COMPANY_FILTER,
    MAIN_IMPORT_SALESORG_FILTER,
    MAIN_IMPORT_CHANNEL_FILTER,
    KEYWORD_FILTER,
    START_DATE_FILTER,
    END_DATE_FILTER,
    DOC_STATUS_FILTER,
    EXPENSE_TYPE_FILTER,
    EXPENSE_TRANSACTION_STATUS_FILTER,
    MENU_NOTIFICATION_REFRESH
} from '../constants/ActionTypes';

import { MAIN_DOCUMENT_TYPE_FILTER } from '../constants/ActionTypes';

export const mainSelectCompany = payload => {
    return {
        type: MAIN_COMPANY_FILTER,
        payload
    }
}

export const mainSelectSalesOrg = payload => {
    return {
        type: MAIN_SALESORG_FILTER,
        payload
    }
}

export const mainSelectChannel = payload => {
    return {
        type: MAIN_CHANNEL_FILTER,
        payload
    }
}

export const mainSelectImportCompany = payload => {
    return {
        type: MAIN_IMPORT_COMPANY_FILTER,
        payload
    }
}

export const mainSelectImportSalesOrg = payload => {
    return {
        type: MAIN_IMPORT_SALESORG_FILTER,
        payload
    }
}

export const mainSelectImportChannel = payload => {
    return {
        type: MAIN_IMPORT_CHANNEL_FILTER,
        payload
    }
}

export const keywordFilter = payload => {
    return {
        type: KEYWORD_FILTER,
        payload
    }
}

export const selectStartDate = payload => {
    return {
        type: START_DATE_FILTER,
        payload
    }
}

export const selectEndDate = payload => {
    return {
        type: END_DATE_FILTER,
        payload
    }
}

export const selectDocStatus = payload => {
    return {
        type: DOC_STATUS_FILTER,
        payload
    }
}

export const selectedExpenseType = payload => {
    return {
        type: EXPENSE_TYPE_FILTER,
        payload
    }
}

export const selectedExpenseTransactionStatus = payload => {
    return {
        type: EXPENSE_TRANSACTION_STATUS_FILTER,
        payload
    }
}

// สั่งให้ SideNav โหลด NotificationCount ใหม่ (ใช้หลังเอกสารเปลี่ยนสถานะ/ถูกสร้าง/ถูกลบ)
export const refreshMenuNotification = () => {
    return {
        type: MENU_NOTIFICATION_REFRESH
    }
}

export const selectDocumentType = payload => {
    return {
        type: MAIN_DOCUMENT_TYPE_FILTER,
        payload
    }
}